import React from 'react';
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { updatePassToCreateField, createPassRequested, cancelCreatePass } from '../../reducers/pass-list'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import TextField from '@material-ui/core/TextField';

function Transition(props) {
  return <Slide direction="left" {...props} />;
}
// NEXT: ADD FULL SCREEN DIALOG
const selectors = {
  isOpen: state => {
    return state.uiControl.newPass.open
  },
  getPassToCreate: state => {
    return state.passList.passToCreate
  }
}
const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    marginLeft: '20%',
    marginRight: '20%',
  },
  textField: {
    marginTop: '40vh'
  },
  menu: {
    width: 200,
  },
});
const NewPassModule = ({ classes, handleClose, handleSave, open, updatePassToCreateField, passToCreate }) => {
  function _handleSave(e) {
    e.preventDefault();
    return handleSave(e);
  }
  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton color="inherit" onClick={handleClose} aria-label="Close">
              <CloseIcon />
            </IconButton>
            <Typography variant="title" color="inherit" className={classes.flex}>
              New Pass
              </Typography>
            <Button color="inherit" onClick={handleSave}>
              save
              </Button>
          </Toolbar>
        </AppBar>
        <form onSubmit={_handleSave} className={classes.container} noValidate autoComplete="off">
          <TextField
            fullWidth
            autoFocus
            id="guest_name"
            label="Name"
            className={classes.textField}
            value={passToCreate.guest_name}
            onChange={updatePassToCreateField}
            margin="normal"
          />
        </form>
      </Dialog>
    </div>
  );
}

NewPassModule.propTypes = {
  open: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  updatePassToCreateField: PropTypes.func.isRequired,
  passToCreate: PropTypes.shape({
    guest_name: PropTypes.string.isRequired
  })
}

const mapStateToProps = (state) => ({
  open: selectors.isOpen(state),
  passToCreate: selectors.getPassToCreate(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleClose: cancelCreatePass,
  updatePassToCreateField,
  handleSave: createPassRequested
}, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(NewPassModule));


// WEBPACK FOOTER //
// ./src/modules/new-pass/index.js